/**
 * 错误提示 + 重试按钮（复用 website ErrorBox 模式）
 */
import type { ReactNode } from 'react';

interface ErrorBoxProps {
  message?: string;
  onRetry?: () => void;
  children?: ReactNode;
}

export default function ErrorBox({ message, onRetry, children }: ErrorBoxProps) {
  return (
    <div className="error-box">
      <div className="error-box-title">😥 加载失败</div>
      <div className="error-box-msg">{message ?? '数据获取失败，请稍后重试'}</div>
      {onRetry ? (
        <button className="btn btn-outline btn-sm" onClick={onRetry}>
          重试
        </button>
      ) : null}
      {children}
    </div>
  );
}
